import { ResetPasswordForm } from '@/components/modules/auth/ResetPasswordForm'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/reset-password')({
  component: ResetPasswordPage,
  validateSearch: (search: Record<string, unknown>) => ({
    reset_password_token: (search.reset_password_token as string) || '',
  }),
})

function ResetPasswordPage() {
  const { reset_password_token: resetPasswordToken } = Route.useSearch()
  return <ResetPasswordForm resetPasswordToken={resetPasswordToken} />
}
